import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "./styles.css";

const localDesktopShell = window.location.hostname === "127.0.0.1" && window.location.port === "8765";
if (localDesktopShell) {
  // The signed Mac app must always use the files in the current local build.
  // Offline PWA caching is for published/mobile views; here it can pair an old
  // editor shell with a newly rebuilt backend and make fixes appear erratic.
  void navigator.serviceWorker?.getRegistrations().then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())));
  void window.caches?.keys().then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))));
} else {
  const controlledAtBoot = Boolean(navigator.serviceWorker?.controller);
  let reloadingForUpdate = false;
  let applyingDeferredUpdate = false;
  let updateSW: ReturnType<typeof registerSW>;
  const applyDeferredUpdate = async () => {
    if (applyingDeferredUpdate) return;
    applyingDeferredUpdate = true;
    const pending: Promise<unknown>[] = [];
    window.dispatchEvent(new CustomEvent("tcc-before-app-update", {
      detail: { waitUntil: (work: Promise<unknown>) => pending.push(Promise.resolve(work)) },
    }));
    await Promise.allSettled(pending);
    await updateSW(true);
  };
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh: () => {
      window.dispatchEvent(new Event("tcc-app-update-ready"));
      window.addEventListener("pagehide", () => void applyDeferredUpdate(), { once: true });
    },
    onRegisteredSW: (_serviceWorkerUrl, registration) => {
      if (registration) window.setInterval(() => void registration.update(), 60 * 60 * 1000);
    }
  });
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (!controlledAtBoot || reloadingForUpdate || document.visibilityState === "hidden") return;
    reloadingForUpdate = true;
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
